import React, { useState } from 'react';
import { useTranslation } from 'next-i18next';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import TabBox from './TabBox';
import Feedback from '../molecules/Feedback';
import ItemReviewForm from '../organisms/ItemReviewForm';
import Empty from '../atoms/Empty';
import Button from '../atoms/Button';
import { byProperty } from '../../lib/utils';
import { getReviewRating } from '../../data/helper';
import styles from '../../styles/components/organisms/ItemReviews.module.scss';
import { Review } from '@prisma/client';

interface ItemReviewsProps {
  type: string;
  data: any;
  access?: boolean;
  setLayer: (el: any) => void;
  apply: (id: string) => void;
}

const ItemReviews = (props: ItemReviewsProps) => {
  const { t } = useTranslation(['common', 'rating']);
  const [tab, setTab] = useState('createdAt-desc');
  const { type, data, setLayer, access } = props;
  const reviews = (data.reviews || [])
    .filter((review: Review) => !!review.review)
    .map((review: Review) => {
      return {
        ...review,
        rating: getReviewRating(review),
      };
    });

  return (
    <>
      <Row>
        <Col xs={8}>
          <TabBox
            bg
            select
            className={styles.reviews}
            onChange={(id) => setTab(id)}
            title={t('rating:feedback')}
            tabs={
              !!reviews.length
                ? [
                    { id: 'createdAt-desc', label: t(`rating:sort:date-desc`) },
                    { id: 'createdAt-asc', label: t(`rating:sort:date-asc`) },
                    { id: 'rating-desc', label: t(`rating:sort:rating-desc`) },
                    { id: 'rating-asc', label: t(`rating:sort:rating-asc`) },
                  ]
                : []
            }
          >
            {!!reviews.length ? (
              reviews
                .sort(byProperty(tab.split('-')[0], tab.split('-')[1]))
                .map((el: any, i: number) => (
                  <Feedback
                    key={i}
                    data={el}
                    access={access}
                    restricted={
                      type === 'venue' &&
                      (data.plan !== 'PLATINUM' ||
                        data.plan !== 'TRIAL_PLATINUM')
                    }
                    setLayer={setLayer}
                  />
                ))
            ) : (
              <Empty label={t('rating:no_feedback')} />
            )}
          </TabBox>
        </Col>
      </Row>

      {/* Review Layer CTA */}
      <Row className="justify-content-center">
        <Col xs={4} sm={3} md={2}>
          <br />
          {!access && (
            <Button
              medium
              full
              label={t(`rating:cta`, { type })}
              onClick={() =>
                setLayer({
                  bg: true,
                  large: true,
                  forced: true,
                  className: styles.reviewFormLayer,
                  children: (
                    <ItemReviewForm
                      type={type}
                      data={data}
                      onComplete={() => setLayer(undefined)}
                    />
                  ),
                })
              }
            />
          )}
          <br />
          <br />
          <br />
        </Col>
      </Row>
    </>
  );
};

export default ItemReviews;
